class IndicadoresAPI {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                console.log("Success Response");
                break;
        }
    }

    //Oportunidad de cita Resolucion 0256
    appointmentOpportunityRes0256(params) {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}indicadores/oportunidad-cita-res0256`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(params)
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    //Indicador de los 10 Correctos
    tenCorrectsIndicator(params) {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}indicadores/10-correctos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicio: params.fecha_inicio,
                    fecha_final: params.fecha_final,
                    id_tercero: params.id_tercero
                })
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    
    //Riesgo de Caida Escala Morse
    async listFallingRisk(params) {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/riesgo-caida`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(params)
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                resolve(null);
            });
        });
    }

    //Riesgo de Caida Escala Morse
    async asignementAppointmentsFromUser(params) {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}indicadores/asignacion-citas-usuario`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(params)
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                resolve(null);
            });
        });
    }

      //Oportunidad de cita 
      appointmentOpportunity(params) {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}indicadores/oportunidad-cita`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(params)
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}

export default new IndicadoresAPI();